import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import CustomGrid from 'common/components/CustomGrid'
import 'dayjs/locale/es'
import WorkerCardSkeleton from './WorkerCardSkeleton'

const WorkersAccordionSkeleton = () => {
  return (
    <Accordion defaultExpanded key={`wrkr-team-acc-1`}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`group1-content`}
        id={`group1-header`}
        key={`group1-header`}
      >
        <Skeleton variant="rectangular" height={40} sx={{ width: '100%' }} />
      </AccordionSummary>
      <AccordionDetails>
        <CustomGrid
          dataSource={[1, 2, 3]}
          count={3}
          gridItemsProps={{ size: { xs: 12, md: 3, sm: 6 } }}
          CardLayout={({ data: employee }) => <WorkerCardSkeleton />}
          gridProps={{ spacing: 2 }}
        />
      </AccordionDetails>
    </Accordion>
  )
}

export default WorkersAccordionSkeleton
